import { useEffect, useState } from "react";
import { useRouter } from "next/router";

export const useYoutubeAPI = () => {
  const apiKey = "AIzaSyADn3OJmmvarJKGlG8vfxqx2WFgzakFv-k";
  const router = useRouter();
// obtention de l'id d'une video à l'aide de url 
function extractYouTubeVideoId(url) {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/|youtube-nocookie\.com\/embed\/|youtube\.com\/attribution_link\?a=)([a-zA-Z0-9_-]{11})/,
  ];
  if(url){
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) {
        return match[1];
      }
    }
  }
 return null;
}




  // obtention des informations sur une video 
  const fetchVideoInfo = async (videoId) => {
    try {
      const videoUrl = `https://www.googleapis.com/youtube/v3/videos?key=${apiKey}&id=${videoId}&part=snippet`;
      const response = await fetch(videoUrl);
      const data = await response.json();

      if (!data.items || data.items.length === 0) {
        router.replace('/404/')
        // throw new Error("La vidéo n'a pas été trouvée.");
      }

      return data.items[0];
    } catch (error) {
      throw error;
    }
  };

  // Fonction pour récupérer les informations sur une chaîne à partir de l'ID de la vidéo
  const fetchChannelInfo = async (videoId) => {
    try {
      const videoInfo = await fetchVideoInfo(videoId);

      if (!videoInfo) {
        router.replace('/404/')

        // throw new Error("La vidéo n'a pas été trouvée.");
      }

      const channelId = videoInfo.snippet.channelId;
      const channelUrl = `https://www.googleapis.com/youtube/v3/channels?key=${apiKey}&id=${channelId}&part=snippet,statistics`;
      const channelResponse = await fetch(channelUrl);
      const channelData = await channelResponse.json();

      if (!channelData.items || channelData.items.length === 0) {
        router.replace('/404/')

        // throw new Error("La chaîne n'a pas été trouvée.");
      }

      return channelData.items[0].snippet;
    } catch (error) {
      throw error;
    }
  };

  // Fonction pour récupérer les commentaires sur une chaîne à partir de l'ID de la vidéo
  const fetchYoutubeComments = async (videoId) => {
    try {
      const apiUrlComments = `https://www.googleapis.com/youtube/v3/commentThreads?part=snippet%2Creplies&videoId=${videoId}&key=${apiKey}`;
      const response = await fetch(apiUrlComments);
      const data = await response.json();

      return data?.items;
    } catch (error) {
      throw error;
    }
  };
  const fetchYoutubeThumbnails = async (videoId) => {
    try {
      const apiUrlThumbnails = `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${apiKey}`;
      const response = await fetch(apiUrlThumbnails);
      const data = await response.json();
      console.log('data',data)
      return data?.items?.[0]?.snippet?.thumbnails?.medium.url;
    } catch (error) {
      throw error;
    }
  };
  const fetchVideoStatistics = async (videoId) => {
    try {
      const apiUrlViews = `https://www.googleapis.com/youtube/v3/videos?part=statistics&id=${videoId}&key=${apiKey}`;
      const responseView = await fetch(apiUrlViews);
      const dataView = await responseView.json();
      return dataView?.items?.[0]?.statistics;
    } catch (error) {
      throw error;
    }
  };
  return {
    extractYouTubeVideoId,
    fetchChannelInfo,
    fetchVideoInfo,
    fetchYoutubeComments,
    fetchYoutubeThumbnails,
    fetchVideoStatistics,
  
  };
};
